import { InfoBox } from "./InfoBox";

export default InfoBox;
